import type { DataApp } from '../IntegrationsRecommendation.types'

export const sortApp = (a: DataApp, b: DataApp): number => {
  const aRecommendation = a.recommendations.find(({ type }) => type === 'SALES')
  const bRecommendation = b.recommendations.find(({ type }) => type === 'SALES')

  if (!aRecommendation || !bRecommendation) return 0

  return aRecommendation.order - bRecommendation.order
}
